import { MapPin, Globe } from "lucide-react";
import { siteConfig } from "@/config/siteConfig";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export const ServiceAreas = () => (
  <section id="bolgeler" data-testid="service-areas-section" className="scroll-mt-20 bg-white py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <SectionHeading
        eyebrow="Hizmet Bölgeleri"
        title="Salihli Merkezli, Türkiye Geneli Hizmet"
        testid="areas-heading"
      />
      <Reveal delay={0.05}>
        <div className="mt-6 max-w-3xl space-y-4 text-base leading-relaxed text-neutral-600">
          <p>
            <strong className="text-ink-900">Salihli oto çekici</strong> ve{" "}
            <strong className="text-ink-900">Salihli oto kurtarma</strong> ihtiyaçlarınızda merkezimiz Salihli'dedir;
            aracınız nerede kaldıysa en kısa yoldan yanınıza geliriz.{" "}
            <strong className="text-ink-900">Manisa oto çekici</strong> ve{" "}
            <strong className="text-ink-900">Manisa araç taşıma</strong> taleplerinde de tüm ilçelere hizmet veriyoruz.
          </p>
          <p>
            <strong className="text-ink-900">İzmir araç taşıma</strong>,{" "}
            <strong className="text-ink-900">Ankara araç taşıma</strong> ve{" "}
            <strong className="text-ink-900">İstanbul araç taşıma</strong> güzergâhlarında düzenli olarak çalışıyoruz.{" "}
            <strong className="text-ink-900">Şehirler arası araç taşıma</strong> taleplerinizde aracınızı bulunduğu
            noktadan alıp Türkiye'nin her yerine güvenle ulaştırıyoruz.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-wrap items-center gap-3">
          <span
            data-testid="area-chip-primary"
            className="inline-flex items-center gap-2 rounded-full bg-brand px-6 py-3 font-display text-lg font-extrabold uppercase tracking-wide text-white shadow-lg shadow-brand/30"
          >
            <MapPin className="h-5 w-5" aria-hidden="true" />
            {siteConfig.primaryRegion}
          </span>
          {siteConfig.regions.map((region) => (
            <span
              key={region}
              data-testid={`area-chip-${region.toLocaleLowerCase("tr")}`}
              className="inline-flex items-center rounded-full border border-ink-100 bg-paper px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-ink-900 transition-colors duration-200 hover:border-brand/40 hover:text-brand"
            >
              {region}
            </span>
          ))}
          <span className="inline-flex items-center gap-2 rounded-full bg-ink-900 px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wide text-white">
            <Globe className="h-4 w-4" aria-hidden="true" />
            Türkiye Geneli
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
